import { Button, notification} from 'antd';
import i18next from "i18next";
import { useEffect } from 'react';

const NotificationComponent = ({ type, text }) => {
    const [api, contextHolder] = notification.useNotification();

    useEffect(() => {
        openNotificationWithIcon(type);
    }, [])

    const getTitle = (type) => { 
        if(type == "error"){
            return i18next.t('common.notification.error.title')
        }
        else{
            return i18next.t('common.notification.error.info')
        }
    }

    const openNotificationWithIcon = (type) => {        
        api[type]({
            message: getTitle(type),
            description: i18next.t('common.notification.' + type + '.' + text)
        });
    };

   
    return (
        <>
            {contextHolder}
        </>
    )
};
export default NotificationComponent;